import { faSortAsc } from "@fortawesome/pro-solid-svg-icons/faSortAsc";
import { faSortDesc } from "@fortawesome/pro-solid-svg-icons/faSortDesc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "~/lib/utils";
import { SortDirection, SortDirections } from "~/modules/filters/types";
import { RowSizes } from "../DataGrid/types";

// // // //

interface Props {
    direction: SortDirection;
    size?: RowSizes;
}

export function SortInput(props: Props) {
    const { direction, size = RowSizes.medium } = props;

    return (
        <span
            className={cn(
                "text-slate-300 group-hover:text-slate-400 transition-colors flex relative",
            )}
        >
            <FontAwesomeIcon
                icon={faSortAsc}
                className={cn({
                    "text-slate-600": direction === SortDirections.asc,
                    "w-2": size === RowSizes.extraSmall,
                    "w-2.5": size !== RowSizes.extraSmall,
                })}
            />
            <FontAwesomeIcon
                icon={faSortDesc}
                className={cn("absolute", {
                    "text-slate-600": direction === SortDirections.desc,
                    "w-2": size === RowSizes.extraSmall,
                    "w-2.5": size !== RowSizes.extraSmall,
                })}
            />
        </span>
    );
}
